// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this CSS to your styles */

/*
.loader-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loader {
  border: 8px solid #f3f3f3; 
  border-top: 8px solid #3498db; 
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

*/



.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid;
  border-top-color: #E30613; 
  border-right-color: #831D74; 
  border-bottom-color: #1B1464; 
  border-left-color: #1B1464; 
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
*/





.timeline {
  position: relative;
  padding: 10px 0;
}

.timeline-date {
  margin-bottom: 10px;
}

.timeline-item {
  display: flex;
  margin-bottom: 10px;
}

.timeline-time {
  min-width: 130px;
  text-align: left;
}

.time-label {
  font-weight: bold;
}

.timeline-icon {
  width: 10px;
  height: 10px;
  background-color: #dc3545;
  border-radius: 50%;
  margin-left: 5px;
}

.timeline-content {
  flex-grow: 1;
}

.detection-group {
  margin-bottom: 5px;
}

.detection-badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 0.85em;
  margin-right: 5px;
  font-weight: bold;
  white-space: nowrap;
}

.badge-high {
  background-color: #f8d7da;
  color: #dc3545;
}

.badge-medium {
  background-color: #fff3cd;
  color: #856404;
}

.badge-low {
  background-color: #d4edda;
  color: #28a745;
}

.pagination-info {
  margin: 0;
}




/* UserActivity.css */

/* Detection Badge Themes */
.badge-low {
  background-color: #d4edda;
  color: #155724;
}

.badge-medium {
  background-color: #fff3cd;
  color: #856404;
}

.badge-high {
  background-color: #f8d7da;
  color: #721c24;
}

/* Date Header */
.date-header {
  background-color: #f8f9fa;
  padding: 10px 15px;
  border-bottom: 1px solid #dee2e6;
  font-size: 1.1rem;
  font-weight: bold;
  color: #343a40;
}

/* Time Header */
.time-header {
  background-color: #e9ecef;
  padding: 8px 15px;
  border-bottom: 1px solid #ced4da;
  font-size: 1rem;
  font-weight: bold;
  color: #495057;
}

/* Detection Item */
.detection-item {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  border-bottom: 1px solid #ced4da;
}

.detection-icon {
  margin-right: 10px;
  color: #17a2b8;
}

.detection-badge {
  margin-right: 5px;
}

/* Pagination Styles */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}

.page-item {
  margin-left: 5px;
}

.page-link {
  padding: 5px 10px;
  border: 1px solid #dee2e6;
  color: #007bff;
  background-color: #fff;
  cursor: pointer;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: background-color 0.2s, color 0.2s;
}

.page-link:hover {
  background-color: #007bff;
  color: #fff;
}

.page-item.active .page-link {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.page-item.disabled .page-link {
  color: #6c757d;
  cursor: not-allowed;
  background-color: #fff;
  border-color: #dee2e6;
}




/* gaugeChartStyles.css */
/*
.gauge-container {
  position: relative;
  height: 200px; 
}

.gauge-bottom-labels {
  position: absolute;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  font-weight: bold;
  color: black;
}

.gauge-bottom-labels .left-label {
  font-size: 16px;
}

.gauge-bottom-labels .right-label {
  font-size: 16px;
}

.device-score-label {
  position: absolute;
  top: 80px; 
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  color: black;
  font-size: 18px;
}*/

/*.user-details .card-body {
    margin-top: 3.125rem;
    z-index: 1;
}
*/

/*

.device-health-chart {
  position: relative; 
}

.gauge-label-left,
.gauge-label-right {
  position: absolute; 
  top: 90%; 
  transform: translateY(-50%); 
  font-size: 16px; 
  color: #000; 
}

.gauge-label-left {
  left: 65px; 

.gauge-label-right {
  right: 75px; 
}

.device-score-label {
  position: absolute; 
  top: 90%; 
  left: 50%; 
  transform: translate(-50%, -50%); 
  font-size: 18px; 
  color: #000; 
  font-weight: bold; 
}
*/



.device-health-chart {
  position: relative; /* Set position relative for positioning child elements */
}

/* Default styles for gauge labels */
.gauge-label-left,
.gauge-label-right {
  position: absolute; /* Position absolutely within the parent */
  top: 90%; /* Center vertically */
  transform: translateY(-50%); /* Adjust to center */
  font-size: 16px; /* Set font size */
  color: #000; /* Set text color */
}

.gauge-label-left {
  left: 65px; /* Position towards the left */
}

.gauge-label-right {
  right: 75px; /* Position towards the right */
}

/* Responsive styles for smaller screens */
@media (max-width: 768px) {
  .gauge-label-left {
    left: 60px; /* Adjust for smaller screens */
  }

  .gauge-label-right {
    right: 50px; /* Adjust for smaller screens */
  }

  .gauge-label-left,
  .gauge-label-right {
    font-size: 14px; /* Reduce font size */
  }

  .device-score-label {
    top: 95%; /* Adjust position for smaller screens */
  }
}

/* Responsive styles for extra small screens */
@media (max-width: 480px) {
  .gauge-label-left {
    left: 30px; /* Further adjustment for extra small screens */
  }

  .gauge-label-right {
    right: 30px; /* Further adjustment for extra small screens */
  }

  .gauge-label-left,
  .gauge-label-right {
    font-size: 12px; /* Further reduce font size */
  }

  .device-score-label {
    font-size: 16px; /* Adjust score label font size */
    top: 80%; /* Further adjust position */
  }
}

/* Device score label styles */
.device-score-label {
  position: absolute; /* Position absolutely within the parent */
  top: 95%; /* Adjust to position below the middle */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust to center */
  font-size: 18px; /* Set font size */
  color: #000; /* Set text color */
  font-weight: bold; /* Make text bold */
}



.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px; /* Adjust based on your design */
}

.loader {
  border: 8px solid rgba(0, 0, 0, 0.1); /* Light border for background */
  border-left-color: #0b76ef; /* Main color for the loader */
  border-radius: 50%;
  width: 50px; /* Size of the loader */
  height: 50px; /* Size of the loader */
  animation: spin 1s linear infinite; /* Animation for spinning */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}




.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #007bff;
  width: 24px;
  height: 24px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}







/* Style for table rows on hover */
.table tbody tr:hover {
  background-color: #333333; /* Light black color */
  color: rgb(41, 98, 255);
}

/* Center loader */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 1.2rem;
  color: #555555;
}

/* Bold table headers */
.table thead th {
  font-weight: bold;
  color: #333;
}

`, "",{"version":3,"sources":["webpack://./src/components/detection-profile/loaderStyles.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;;;;;;;;;;;;;;;;;;;;;;CAsBC;;;;AAID;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC;;;;;;AAMD;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;;;;AAKA,qBAAqB;;AAErB,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;;;;AAKA,yBAAyB;AACzB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiCE;;AAEF;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA+BC;;;;AAID;EACE,kBAAkB,EAAE,yDAAyD;AAC/E;;AAEA,oCAAoC;AACpC;;EAEE,kBAAkB,EAAE,0CAA0C;EAC9D,QAAQ,EAAE,sBAAsB;EAChC,2BAA2B,EAAE,qBAAqB;EAClD,eAAe,EAAE,kBAAkB;EACnC,WAAW,EAAE,mBAAmB;AAClC;;AAEA;EACE,UAAU,EAAE,8BAA8B;AAC5C;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU,EAAE,+BAA+B;EAC7C;;EAEA;IACE,WAAW,EAAE,+BAA+B;EAC9C;;EAEA;;IAEE,eAAe,EAAE,qBAAqB;EACxC;;EAEA;IACE,QAAQ,EAAE,wCAAwC;EACpD;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU,EAAE,+CAA+C;EAC7D;;EAEA;IACE,WAAW,EAAE,+CAA+C;EAC9D;;EAEA;;IAEE,eAAe,EAAE,6BAA6B;EAChD;;EAEA;IACE,eAAe,EAAE,iCAAiC;IAClD,QAAQ,EAAE,4BAA4B;EACxC;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB,EAAE,0CAA0C;EAC9D,QAAQ,EAAE,wCAAwC;EAClD,SAAS,EAAE,wBAAwB;EACnC,gCAAgC,EAAE,qBAAqB;EACvD,eAAe,EAAE,kBAAkB;EACnC,WAAW,EAAE,mBAAmB;EAChC,iBAAiB,EAAE,mBAAmB;AACxC;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,oCAAoC,EAAE,gCAAgC;EACtE,0BAA0B,EAAE,8BAA8B;EAC1D,kBAAkB;EAClB,WAAW,EAAE,uBAAuB;EACpC,YAAY,EAAE,uBAAuB;EACrC,kCAAkC,EAAE,2BAA2B;AACjE;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;;;AAKA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;;;;;;AAQA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,sBAAsB;EACjD,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":["/* Add this CSS to your styles */\n\n/*\n.loader-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.loader {\n  border: 8px solid #f3f3f3; \n  border-top: 8px solid #3498db; \n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n*/\n\n\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border-left-color: #09f;\n  animation: spin 1s ease infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 4px solid;\n  border-top-color: #E30613; \n  border-right-color: #831D74; \n  border-bottom-color: #1B1464; \n  border-left-color: #1B1464; \n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n*/\n\n\n\n\n\n.timeline {\n  position: relative;\n  padding: 10px 0;\n}\n\n.timeline-date {\n  margin-bottom: 10px;\n}\n\n.timeline-item {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.timeline-time {\n  min-width: 130px;\n  text-align: left;\n}\n\n.time-label {\n  font-weight: bold;\n}\n\n.timeline-icon {\n  width: 10px;\n  height: 10px;\n  background-color: #dc3545;\n  border-radius: 50%;\n  margin-left: 5px;\n}\n\n.timeline-content {\n  flex-grow: 1;\n}\n\n.detection-group {\n  margin-bottom: 5px;\n}\n\n.detection-badge {\n  display: inline-block;\n  padding: 5px 10px;\n  border-radius: 12px;\n  font-size: 0.85em;\n  margin-right: 5px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.badge-high {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n.badge-medium {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.badge-low {\n  background-color: #d4edda;\n  color: #28a745;\n}\n\n.pagination-info {\n  margin: 0;\n}\n\n\n\n\n/* UserActivity.css */\n\n/* Detection Badge Themes */\n.badge-low {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.badge-medium {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.badge-high {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* Date Header */\n.date-header {\n  background-color: #f8f9fa;\n  padding: 10px 15px;\n  border-bottom: 1px solid #dee2e6;\n  font-size: 1.1rem;\n  font-weight: bold;\n  color: #343a40;\n}\n\n/* Time Header */\n.time-header {\n  background-color: #e9ecef;\n  padding: 8px 15px;\n  border-bottom: 1px solid #ced4da;\n  font-size: 1rem;\n  font-weight: bold;\n  color: #495057;\n}\n\n/* Detection Item */\n.detection-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 15px;\n  border-bottom: 1px solid #ced4da;\n}\n\n.detection-icon {\n  margin-right: 10px;\n  color: #17a2b8;\n}\n\n.detection-badge {\n  margin-right: 5px;\n}\n\n/* Pagination Styles */\n.pagination-container {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 15px;\n}\n\n.pagination {\n  display: flex;\n  list-style: none;\n  padding: 0;\n}\n\n.page-item {\n  margin-left: 5px;\n}\n\n.page-link {\n  padding: 5px 10px;\n  border: 1px solid #dee2e6;\n  color: #007bff;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.page-link:hover {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.page-item.active .page-link {\n  background-color: #007bff;\n  color: #fff;\n  border-color: #007bff;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n\n\n\n/* gaugeChartStyles.css */\n/*\n.gauge-container {\n  position: relative;\n  height: 200px; \n}\n\n.gauge-bottom-labels {\n  position: absolute;\n  bottom: 10px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 10px;\n  font-weight: bold;\n  color: black;\n}\n\n.gauge-bottom-labels .left-label {\n  font-size: 16px;\n}\n\n.gauge-bottom-labels .right-label {\n  font-size: 16px;\n}\n\n.device-score-label {\n  position: absolute;\n  top: 80px; \n  left: 50%;\n  transform: translateX(-50%);\n  font-weight: bold;\n  color: black;\n  font-size: 18px;\n}*/\n\n/*.user-details .card-body {\n    margin-top: 3.125rem;\n    z-index: 1;\n}\n*/\n\n/*\n\n.device-health-chart {\n  position: relative; \n}\n\n.gauge-label-left,\n.gauge-label-right {\n  position: absolute; \n  top: 90%; \n  transform: translateY(-50%); \n  font-size: 16px; \n  color: #000; \n}\n\n.gauge-label-left {\n  left: 65px; \n\n.gauge-label-right {\n  right: 75px; \n}\n\n.device-score-label {\n  position: absolute; \n  top: 90%; \n  left: 50%; \n  transform: translate(-50%, -50%); \n  font-size: 18px; \n  color: #000; \n  font-weight: bold; \n}\n*/\n\n\n\n.device-health-chart {\n  position: relative; /* Set position relative for positioning child elements */\n}\n\n/* Default styles for gauge labels */\n.gauge-label-left,\n.gauge-label-right {\n  position: absolute; /* Position absolutely within the parent */\n  top: 90%; /* Center vertically */\n  transform: translateY(-50%); /* Adjust to center */\n  font-size: 16px; /* Set font size */\n  color: #000; /* Set text color */\n}\n\n.gauge-label-left {\n  left: 65px; /* Position towards the left */\n}\n\n.gauge-label-right {\n  right: 75px; /* Position towards the right */\n}\n\n/* Responsive styles for smaller screens */\n@media (max-width: 768px) {\n  .gauge-label-left {\n    left: 60px; /* Adjust for smaller screens */\n  }\n\n  .gauge-label-right {\n    right: 50px; /* Adjust for smaller screens */\n  }\n\n  .gauge-label-left,\n  .gauge-label-right {\n    font-size: 14px; /* Reduce font size */\n  }\n\n  .device-score-label {\n    top: 95%; /* Adjust position for smaller screens */\n  }\n}\n\n/* Responsive styles for extra small screens */\n@media (max-width: 480px) {\n  .gauge-label-left {\n    left: 30px; /* Further adjustment for extra small screens */\n  }\n\n  .gauge-label-right {\n    right: 30px; /* Further adjustment for extra small screens */\n  }\n\n  .gauge-label-left,\n  .gauge-label-right {\n    font-size: 12px; /* Further reduce font size */\n  }\n\n  .device-score-label {\n    font-size: 16px; /* Adjust score label font size */\n    top: 80%; /* Further adjust position */\n  }\n}\n\n/* Device score label styles */\n.device-score-label {\n  position: absolute; /* Position absolutely within the parent */\n  top: 95%; /* Adjust to position below the middle */\n  left: 50%; /* Center horizontally */\n  transform: translate(-50%, -50%); /* Adjust to center */\n  font-size: 18px; /* Set font size */\n  color: #000; /* Set text color */\n  font-weight: bold; /* Make text bold */\n}\n\n\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px; /* Adjust based on your design */\n}\n\n.loader {\n  border: 8px solid rgba(0, 0, 0, 0.1); /* Light border for background */\n  border-left-color: #0b76ef; /* Main color for the loader */\n  border-radius: 50%;\n  width: 50px; /* Size of the loader */\n  height: 50px; /* Size of the loader */\n  animation: spin 1s linear infinite; /* Animation for spinning */\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #007bff;\n  width: 24px;\n  height: 24px;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n\n\n\n\n/* Style for table rows on hover */\n.table tbody tr:hover {\n  background-color: #333333; /* Light black color */\n  color: rgb(41, 98, 255);\n}\n\n/* Center loader */\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  font-size: 1.2rem;\n  color: #555555;\n}\n\n/* Bold table headers */\n.table thead th {\n  font-weight: bold;\n  color: #333;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
